module.exports = __webpack_public_path__ + "static/images/idCard-2.245b992.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/idCard-2.png
// module id = 5bpe
// module chunks = 0